export default __webpack_public_path__ + "static/media/mapFrameLandrangerCY.2e833f75.jpg";